import React from 'react';

export function PseudoInput({ label, value }: { label: string, value: string }) {
  return (
    <p>
      <dfn className="form2-pseudo-input font-bold-15-19">{label}</dfn>
      <span className="font-regular-15-19">{value}</span>
    </p>
  );
}
